import type { ReactNode, RefObject } from 'react';
import { ResultsFiltersSheet } from '../../shared/results_page/results_filters_sheet.js';
import {
  HotelResultsFilters,
  type HotelFilterableOffer,
  type HotelResultsFiltersCopy,
  type HotelResultsFilterValue,
} from './hotel_results_filters.js';
import { HotelResultsFiltersSkeleton } from './hotel_results_filters_skeleton.js';

/**
 * Os filtros do hotel no palco ESTREITO (#2663): a folha de filtros da casca
 * (`ResultsFiltersSheet`, rascunho + Aplicar) com o painel de cortes do hotel
 * dentro.
 */
export function HotelResultsFiltersSheet({
  open,
  onOpenChange,
  returnFocusTo,
  offers,
  currency,
  value,
  copy,
  locked,
  countsPartial,
  searching = false,
  onApply,
  onCommandSubmit,
}: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  /** O botão `Filtros` que abriu a folha — recebe o foco de volta ao fechar. */
  readonly returnFocusTo: RefObject<HTMLElement | null>;
  readonly offers: readonly HotelFilterableOffer[];
  readonly currency: string;
  /** O corte APLICADO — a semente do rascunho a cada abertura. */
  readonly value: HotelResultsFilterValue;
  readonly copy: HotelResultsFiltersCopy;
  readonly locked: boolean;
  readonly countsPartial: boolean;
  /** A busca inicial em voo: sem ofertas, o esqueleto no lugar das seções (#5507). */
  readonly searching?: boolean;
  /** O rascunho cometido — a única escrita que sai daqui. */
  readonly onApply: (value: HotelResultsFilterValue) => void;
  readonly onCommandSubmit?: (command: string) => void;
}): ReactNode {
  return (
    <ResultsFiltersSheet
      open={open}
      onOpenChange={onOpenChange}
      returnFocusTo={returnFocusTo}
      value={value}
      label={copy.filtersLabel}
      applyLabel={copy.applyFiltersLabel}
      locked={locked}
      onApply={onApply}
    >
      {({ draft, setDraft, close }) =>
        searching ? (
          <HotelResultsFiltersSkeleton copy={copy} onClose={close} />
        ) : (
          <HotelResultsFilters
            offers={offers}
            currency={currency}
            value={draft}
            copy={copy}
            locked={locked}
            countsPartial={countsPartial}
            frame={false}
            dismiss="close"
            onChange={setDraft}
            onCollapse={close}
            {...(onCommandSubmit ? { onCommandSubmit } : {})}
          />
        )
      }
    </ResultsFiltersSheet>
  );
}
